import { mergeToken } from 'antd/es/theme/internal';

var antPrefixCls = '.ant-timeline';
var genTimelineStyle = function genTimelineStyle(token) {
  var _right, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _antPrefixCls, _ref7;
  return _ref7 = {}, _ref7[antPrefixCls] = (_antPrefixCls = {}, _antPrefixCls[antPrefixCls + "-item"] = {
    '&-tail': {
      insetBlockStart: token.timeLineItemHeadSize * 1.5,
      insetBlockEnd: token.timeLineItemHeadSize * 1.5,
      insetInlineStart: (token.timeLineItemHeadSize - token.timeLineItemTailWidth) / 2,
      height: "calc(100% - " + token.timeLineItemHeadSize * 2 + "px)",
      borderInlineStart: token.timeLineItemTailWidth + "px " + token.lineType + " " + token.colorSplit
    },
    '&-head': {
      width: token.timeLineItemHeadSize,
      height: token.timeLineItemHeadSize,
      '&-blue': {
        backgroundColor: token.colorPrimary
      },
      '&-red': {
        backgroundColor: token.colorError
      },
      '&-green': {
        backgroundColor: token.colorSuccess
      },
      '&-gray': {
        backgroundColor: token.colorTextQuaternary
      }
    },
    '&-head-custom': {
      insetBlockStart: 1,
      insetInlineStart: 5
    },
    '&-content': {
      insetBlockStart: -5,
      // 圆点和右侧文字间距8px
      marginInlineStart: token.margin
    }
  }, _antPrefixCls["&" + antPrefixCls + "-alternate,\n      &" + antPrefixCls + "-right,\n      &" + antPrefixCls + "-label"] = (_ref6 = {}, _ref6[antPrefixCls + "-item"] = {
    '&-head': {
      marginInlineStart: -5,
      '&-custom': {
        marginInlineStart: 0,
        insetBlockStart: 0
      }
    },
    '&-right': (_right = {}, _right[antPrefixCls + "-item-content"] = {
      paddingRight: token.timeLineItemHeadSize
    }, _right)
  }, _ref6["&" + antPrefixCls + "-right"] = (_ref2 = {}, _ref2[antPrefixCls + "-item-right"] = (_ref = {}, _ref[antPrefixCls + "-item-tail,\n              " + antPrefixCls + "-item-head,\n              " + antPrefixCls + "-item-head-custom"] = {
    insetInlineStart: "calc(100% - " + (token.timeLineItemHeadSize + token.timeLineItemTailWidth) / 2 + "px)"
  }, _ref[antPrefixCls + "-item-content"] = {
    width: "calc(100% - " + (token.timeLineItemHeadSize + token.marginXS) + "px)"
  }, _ref), _ref2), _ref6["&" + antPrefixCls + "-pending\n        " + antPrefixCls + "-item-last\n        " + antPrefixCls + "-item-tail"] = {
    borderInlineStart: token.timeLineItemTailWidth + "px dotted " + token.colorSplit
  }, _ref6["&" + antPrefixCls + "-reverse " + antPrefixCls + "-item-pending"] = (_ref3 = {}, _ref3[antPrefixCls + "-item-tail"] = {
    borderInlineStart: token.timeLineItemTailWidth + "px dotted " + token.colorSplit
  }, _ref3), _ref6["&" + antPrefixCls + "-label"] = (_ref5 = {}, _ref5[antPrefixCls + "-item-label"] = {
    insetBlockStart: -5,
    color: token.colorTextTertiary,
    paddingRight: token.timeLineItemHeadSize
  }, _ref5[antPrefixCls + "-item-right"] = (_ref4 = {}, _ref4[antPrefixCls + "-item-label"] = {
    insetInlineStart: "calc(50% + " + token.timeLineItemHeadSize * 2 + "px)",
    width: "calc(50% - " + token.marginSM + "px)",
    textAlign: 'start'
  }, _ref4), _ref5), _ref6), _antPrefixCls), _ref7;
};
var timelineStyleFn = function timelineStyleFn(token) {
  var timeLineToken = mergeToken(token, {
    timeLineItemHeadSize: 12,
    // 中间灰色连接线1px
    // https://cooper.didichuxing.com/docs/document/2200512335156
    timeLineItemTailWidth: token.lineWidthBold
  });
  return genTimelineStyle(timeLineToken);
};

export { timelineStyleFn };
